import React from 'react';
import { QuestionRendererProps } from './QuestionRenderer';

const NumberInputRenderer: React.FC<Omit<QuestionRendererProps, 'questionNumber'>> = ({
  question,
  value,
  onChange,
  error,
}) => {
  const min = question.settings?.minValue;
  const max = question.settings?.maxValue;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    onChange(newValue === '' ? undefined : Number(newValue));
  };

  return (
    <div>
      <input
        type="number"
        value={value ?? ''}
        onChange={handleChange}
        placeholder={question.placeholder}
        min={min}
        max={max}
        step="any"
        className={`w-full px-4 py-3 border rounded-lg transition-colors ${
          error
            ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
            : 'border-gray-300 focus:border-blue-500 focus:ring-blue-500'
        } focus:outline-none focus:ring-2`}
        aria-invalid={!!error}
        aria-describedby={error ? `${question.id}-error` : undefined}
      />
      {(min !== undefined || max !== undefined) && (
        <p className="text-sm text-gray-500 mt-1">
          {min !== undefined && max !== undefined && `Value must be between ${min} and ${max}`}
          {min !== undefined && max === undefined && `Minimum value: ${min}`}
          {min === undefined && max !== undefined && `Maximum value: ${max}`}
        </p>
      )}
    </div>
  );
};

export default NumberInputRenderer;
